import { useHotkeys } from 'react-hotkeys-hook';

import { useFullscreenContext } from '~/components/AssetModalV2/shared/context/FullscreenContext';

let _stopEscKeyPropagation = false;
const _assetModalEscKeyHandlers: Array<() => void> = [];

export const stopEscKeyPropagationOnAssetDetailsModal = (nextValue: boolean) => {
  _stopEscKeyPropagation = nextValue;
};

export const registerAssetModalEscKeyHandler = (handler: () => void) => {
  _assetModalEscKeyHandlers.push(handler);

  return () => {
    const handlerIndex = _assetModalEscKeyHandlers.lastIndexOf(handler);

    if (handlerIndex !== -1) {
      _assetModalEscKeyHandlers.splice(handlerIndex, 1);
    }
  };
};

export type UseAssetModalEscKeyHandlerProps = {
  onClose: () => void;
};

export const useAssetModalEscKeyHandler = ({ onClose }: UseAssetModalEscKeyHandlerProps) => {
  const { isFullscreen } = useFullscreenContext();
  const closeAssetModal = onClose;

  useHotkeys(
    'esc',
    () => {
      if (_stopEscKeyPropagation) {
        return;
      }

      const registeredHandler = _assetModalEscKeyHandlers[_assetModalEscKeyHandlers.length - 1];

      if (registeredHandler) {
        registeredHandler();
        return;
      }

      closeAssetModal();
    },
    {
      enabled: !isFullscreen,
    },
    [closeAssetModal],
  );
};
